export const setAuthData = (token, admin) => {
  localStorage.setItem('adminToken', token);
  localStorage.setItem('adminUser', JSON.stringify(admin));
  localStorage.setItem('loginTime', new Date().toISOString());
};

export const getToken = () => {
  return localStorage.getItem('adminToken');
};

export const getAdmin = () => {
  const adminStr = localStorage.getItem('adminUser');
  if (adminStr) {
    try {
      return JSON.parse(adminStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const isLoggedIn = () => {
  const token = getToken();
  return !!token;
};

export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
  localStorage.removeItem('loginTime');
  window.location.href = '/admin/login';
};
